import { ReactComponent as IconCore } from "@/styles/assets/svg/icon_exercise_core.svg";
import { ReactComponent as IconClose } from "@/styles/assets/svg/icon_exercise_close.svg";
import { ReactComponent as IconReady } from "@/styles/assets/svg/icon_exercise_ready.svg";
import { ReactComponent as IconCardio } from "@/styles/assets/svg/icon_exercise_cardio.svg";
import { ReactComponent as IconExtremity } from "@/styles/assets/svg/icon_exercise_extremity.svg";

export const baseExerciseCategories = [
  {
    id: 1,
    title: "준비운동",
    category: "READY",
    icon: <IconReady />,
    path: "/exercise/partby/READY",
    count: 0,
  },
  {
    id: 2,
    title: "상하지 운동",
    category: "LIMBS",
    icon: <IconExtremity />,
    path: "/exercise/partby/LIMBS",
    count: 0,
  },
  {
    id: 3,
    title: "코어운동",
    category: "CORE",
    icon: <IconCore />,
    path: "/exercise/partby/CORE",
    count: 0,
  },
  {
    id: 4,
    title: "전신유산소 운동",
    category: "CARDIO",
    icon: <IconCardio />,
    path: "/exercise/partby/CARDIO",
    count: 0,
  },
  {
    id: 5,
    title: "마무리 운동",
    category: "COOL_DOWN",
    icon: <IconClose />,
    path: "/exercise/partby/COOL_DOWN",
    count: 0,
  },
];

export const baseWeekExerciseCategories = [
  {
    id: 2,
    title: "[1~3주차] 관리 운동",
    category: "ONE_QUATER",
    icon: <IconReady />,
    path: "/exercise/set/1",
    count: 0,
    thumbnailUrl: "https://img.youtube.com/vi/IALCwcT0qO0/hqdefault.jpg",
  },
  {
    id: 2,
    title: "[4~8주차] 관리 운동",
    category: "TWO_QUATER",
    icon: <IconExtremity />,
    path: "/exercise/set/2",
    count: 0,
    thumbnailUrl: "https://img.youtube.com/vi/WerfCotKF7M/hqdefault.jpg",
  },
  {
    id: 3,
    title: "[9~12주차] 관리 운동",
    category: "THR_QUATER",
    icon: <IconCore />,
    path: "/exercise/set/3",
    count: 0,
    thumbnailUrl: "https://img.youtube.com/vi/IqTNo6rwsuM/hqdefault.jpg",
  },
];

export const exercisePartCategory = [
  {
    id: "READY",
    title: "준비",
  },
  {
    id: "LIMBS",
    title: "상하지",
  },
  {
    id: "CORE",
    title: "코어",
  },
  {
    id: "CARDIO",
    title: "전신유산소",
  },
  {
    id: "COOL_DOWN",
    title: "마무리",
  },
];

export const exerciseSetCategory = [
  // {
  //   id: "EVENT",
  //   title: "EVENT",
  // },
  {
    id: "1",
    title: "1~3주차",
  },
  {
    id: "2",
    title: "4~8주차",
  },
  {
    id: "3",
    title: "9~12주차",
  },
];

export const ResultCategory = [
  {
    id: 1,
    title: "건강정보",
  },
  {
    id: 2,
    title: "신체기능",
  },
];

export const faqPartCategory = [
  {
    id: "SERVICE",
    title: "서비스",
  },
  // {
  //   id: "POINT",
  //   title: "포인트",
  // },
  {
    id: "EVENT",
    title: "이벤트",
  },
  {
    id: "ACCOUNT",
    title: "계정",
  },
];
